import type { CreatePrivateEventInput } from '../../api/privateEvents';

import { parseDealValueCents } from './private-event-fields';
import type { PrivateEventFormFields as Fields } from './private-event-form-state';
import { buildLocationInput } from './private-event-location-input';

/** Which drawer step shows each request field's error. Anything unlisted
 *  (deal value, HubSpot, add-ons, notes) belongs to the last step. */
const FIELD_STEP: Record<string, number> = {
  regionId: 0,
  venueId: 0,
  locationName: 0,
  addressLine1: 0,
  city: 0,
  state: 0,
  zipCode: 0,
  timeZone: 0,
  locationTbd: 0,
  workshopTypeId: 0,
  startsAt: 0,
  endsAt: 0,
  startTime: 0,
  endTime: 0,
  clientName: 1,
  headcount: 1,
  contactName: 1,
  contactEmail: 1,
  contactPhone: 1,
};
const LAST_STEP = 2;

export function stepOfField(field: string): number {
  return FIELD_STEP[field] ?? LAST_STEP;
}

/** The earliest step touched by any of the given field errors. */
export function firstErrorStep(fieldErrors: Record<string, string>): number {
  const steps = Object.keys(fieldErrors).map(stepOfField);
  return steps.length > 0 ? Math.min(...steps) : 0;
}

function commonPayload(f: Fields) {
  return {
    workshopTypeId: f.workshopTypeId,
    // A bare wall clock with NO zone: the server derives the instant through
    // the event's zone, so a `Z` here would move the event.
    startsAt: `${f.date}T${f.startTime}:00`,
    endsAt: `${f.date}T${f.endTime}:00`,
    clientName: f.clientName.trim(),
    headcount: Number(f.headcount),
    dealValueCents: parseDealValueCents(f.dealValue) ?? null,
    hubspotDealId: f.hubspotDealId.trim() || null,
    contactName: f.contactName.trim() || null,
    contactEmail: f.contactEmail.trim() || null,
    contactPhone: f.contactPhone.trim() || null,
    addOns: f.addOns,
    notes: f.notes.trim() || null,
  };
}

export function buildCreateInput(f: Fields): CreatePrivateEventInput {
  return { ...commonPayload(f), ...buildLocationInput(f) } as CreatePrivateEventInput;
}
